"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconCalendar = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M17,13 L12,13 L12,18 L17,18 L17,13 Z M16,2 L16,4 L8,4 L8,2 L6,2 L6,4 L3.01,4 L3,22 L21,22 L21,4 L18,4 L18,2 L16,2 Z M19,20 L5,20 L5,9 L19,9 L19,20 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconCalendar')(IconCalendar);